module.exports = __webpack_public_path__ + "dot.7b9355ad.svg";